import * as referralsActions from '../actions/referrals';
import { Referrals } from '../models/referrals';

export interface State {
  loaded: boolean;
  loading: boolean;
  referrals: Referrals;
  errors?: any[];
}

export const initialState: State = {
  loaded: false,
  loading: false,
  referrals: null,
  errors: [],
};

export function reducer(
  state: State = initialState,
  action: referralsActions.All
): State {
  switch (action.type) {
    case referralsActions.LOAD_REFERRALS: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }

    case referralsActions.LOAD_REFERRALS_SUCCESS: {
      return {
        ...state,
        referrals: action.payload,
        loaded: true,
        loading: false,
        errors: null,
      };
    }

    case referralsActions.REFERRALS_ACTION_FAIL: {
      return {
        ...state,
        loaded: true,
        loading: false,
        errors: action.payload.error,
      };
    }

    case referralsActions.CLEAR_REFERRALS: {
      return { ...state, referrals: null, errors: null };
    }

    case referralsActions.REFERRALS_CLEAR_ERRORS: {
      return {
        ...state,
        errors: [],
      };
    }

    default: {
      return state;
    }
  }
}

export const getReferralsErrors = (state: State) => state.errors;
export const getReferrals = (state: State) => state.referrals;
